import React, { Component } from 'react';
import FeedbackPreview from './feedbackPreview/feedbackPreview.js';
import './feedbackList.css';

class FeedbackList extends Component {

  state = {

  }

  componentDidMount() {

  }

  render() {

    return (
      <div className="FeedbackListPage">
        {this.props.feedback.map(feedback => {
          return <FeedbackPreview feedback={feedback} key={feedback.id} updateFeedbackState={this.props.updateFeedbackState}/>;
        })}
      </div>
    );

  }

}

export default FeedbackList;


// WEBPACK FOOTER //
// ./src/components/content/feedback/feedbackList/feedbackList.js